<mat-form-field appearance="outline" [class.static-height]="!control().dynamicHeight()">
    @if (label() !== undefined || control().required()) {
        <mat-label>{{ label() }}</mat-label>
    }
    <ng-content />
    @if (suffixString() || iconName() || (hint() && hintType()) || control().clearable()) {
        <span matSuffix class="small-margin-left field-suffix">
            @if (suffixString()) {
                {{ suffixString() }}
            }
            @if (control().clearable()) {
                <ui-icon-button iconName="remove" size="small" boundaries="icon" (click)="clear($event)" />
            }
            @if (iconName()) {
                <ui-icon size="small" [name]="iconName()" />
            }
            @if (hint()) {
                @switch (hintType()) {
                    @case ('info') {
                        <ui-icon size="small" name="info" [advizeoTooltip]="hint()" />
                    }
                    @case ('warning') {
                        <ui-icon color="failure" size="small" name="warning" [advizeoTooltip]="hint()" />
                    }
                }
            }
        </span>
    }
    @for (error of displayedErrors(); track error) {
        <mat-error>
            <ng-container *ngTemplateOutlet="error.template()" />
        </mat-error>
    }
    @for (hint of hintsComponents(); track hint) {
        <mat-hint>
            <ng-container *ngTemplateOutlet="hint.template()" />
        </mat-hint>
    }

    <ng-container [uiFormFieldControlToMatFormFieldControl]="control()" />
</mat-form-field>

<!-- The following will not be projected in ng-content -->
@if (false) {
    <ng-content select="ui-form-error" />
}
